/* Vapor95 email popup (sections/v95-email-popup.liquid; every setting is in the theme editor).
   Opens once the shopper scrolls a little (pixels) or reaches the set page depth; an optional timer (0 = off,
   the default since 2026-10-11: a timed popup became the page's "largest content" for Google). Closing it keeps it away for the set
   number of days; signing up keeps it away for good (per browser). Add ?v95popup=1 to any address to
   open it right away. In the theme editor it stays open and the form only previews the thank-you step. */
(function () {
  var KEY = 'v95_email_popup';
  var DAY = 864e5;
  var current = null; // the running popup, so the theme editor can rebuild it after each change

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  function start() {
    if (current) current.destroy();
    current = null;
    var cfg = document.querySelector('[data-v95-ep-config]');
    var tpl = document.getElementById('v95-ep-tpl');
    if (!cfg || !tpl) return;
    current = popup(cfg, tpl);
  }

  function popup(cfg, tpl) {
    var d = cfg.dataset;
    var editor = d.editor === 'true';
    var params = new URLSearchParams(location.search);
    var force = editor || params.get('v95popup') === '1';
    var root, panel, form, input, msg, submitBtn, lastFocus, openedAt = 0, opened = false, dead = false, timer, waits = 0;
    var api = { destroy: destroy, open: function () { open(); }, close: function () { close(); } };

    if (!force) {
      var saved = read();
      var fromEmail = /email|listmonk|klaviyo|newsletter/i.test((params.get('utm_medium') || '') + ' ' + (params.get('utm_source') || ''));
      if (fromEmail && d.emailVisits === 'true') { write({ done: true, at: Date.now(), why: 'email-visit' }); return api; }
      if (saved.done) return api;
      if (saved.closed && Date.now() - saved.closed < (Number(d.days) || 14) * DAY) return api;
      var phone = matchMedia('(max-width: 749px)').matches;
      if ((d.device === 'mobile' && !phone) || (d.device === 'desktop' && phone)) return api;
    }

    // the stylesheet and the background photo load together so the window never opens without its sky
    function loadAssets() {
      var photo = new Promise(function (ok) {
        if (!d.photo) return ok();
        var img = new Image();
        img.onload = img.onerror = function () { ok(); };
        img.src = d.photo;
        setTimeout(ok, 2500);
      });
      if (document.querySelector('link[data-v95-ep-css]')) return photo;
      return Promise.all([photo, new Promise(function (ok) {
        var l = document.createElement('link');
        l.rel = 'stylesheet'; l.href = d.css; l.setAttribute('data-v95-ep-css', '');
        l.onload = l.onerror = function () { ok(); };
        document.head.appendChild(l);
      })]);
    }

    function shopHref() {
      var target = d.shopLink || (location.pathname + location.search.replace(/[?&]v95popup=1/, ''));
      try { var u = new URL(target, location.origin); if (u.origin === location.origin) target = u.pathname + u.search; } catch (e) {}
      if (d.applyCode === 'true' && d.code) return '/discount/' + encodeURIComponent(d.code) + '?redirect=' + encodeURIComponent(target);
      return target;
    }

    function focusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input:not([tabindex="-1"]), [tabindex="0"]'),
        function (el) { return el.getClientRects().length > 0; }
      );
    }

    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      if (opened || dead) return;
      opened = true;
      cleanupTriggers();
      // another dialog (cart drawer, menu, quick view) is open: wait for it to close
      // (closed drawers such as MegaCart stay in the page off screen, so a dialog only counts when it is on screen)
      var busy = Array.prototype.some.call(document.querySelectorAll('[role="dialog"], [aria-modal="true"]'), function (el) {
        if (el.checkVisibility && !el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return false;
        var r = el.getBoundingClientRect();
        var w = Math.min(r.right, innerWidth) - Math.max(r.left, 0), h = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
        return w > 40 && h > 40;
      });
      if (busy && !force && waits < 6) { waits++; opened = false; timer = setTimeout(open, 8000); return; }
      // wake the signup service so the first submit is quick
      if (!editor) fetch(d.endpoint.replace(/\/subscribe$/, '/health'), { mode: 'cors' }).catch(function () {});
      loadAssets().then(function () {
        if (dead) return;
        document.body.appendChild(tpl.content.cloneNode(true));
        var all = document.querySelectorAll('body > [data-v95-ep]');
        root = all[all.length - 1];
        panel = root.querySelector('[role="dialog"]');
        form = root.querySelector('[data-v95-ep-form]');
        input = form.querySelector('input[type="email"]');
        msg = root.querySelector('[data-v95-ep-msg]');
        submitBtn = root.querySelector('[data-v95-ep-submit]');
        var shop = root.querySelector('[data-v95-ep-shop]');
        if (shop) shop.href = shopHref();

        root.querySelectorAll('[data-v95-ep-close]').forEach(function (b) { b.addEventListener('click', close); });
        var copyBtn = root.querySelector('[data-v95-ep-copy]');
        if (copyBtn) copyBtn.addEventListener('click', copy);
        form.addEventListener('submit', submit);
        input.addEventListener('input', function () { msg.textContent = ''; input.removeAttribute('aria-invalid'); });
        document.addEventListener('keydown', onKey);

        lastFocus = document.activeElement;
        root.hidden = false;
        if (!editor) document.documentElement.classList.add('v95-ep-lock');
        if (editor && d.preview === 'done') showDone(true);
        requestAnimationFrame(function () { root && root.classList.add('is-open'); });
        openedAt = Date.now();
        if (editor) return;
        // on phones, focusing the field would throw the keyboard up before anyone asked for it
        if (matchMedia('(pointer: fine)').matches) input.focus({ preventScroll: true });
        else panel.focus({ preventScroll: true });
      });
    }

    function close() {
      if (!root) return;
      var finished = !root.querySelector('[data-v95-ep-step="done"]').hidden;
      if (!finished && !force) write({ closed: Date.now() });
      root.classList.remove('is-open');
      document.documentElement.classList.remove('v95-ep-lock');
      document.removeEventListener('keydown', onKey);
      var r = root;
      setTimeout(function () { r.remove(); }, 300);
      root = null;
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      // in the editor, closing stays closed; selecting the section in the sidebar opens it again
      if (editor) opened = false;
    }

    function say(text) { msg.textContent = text; }

    function submit(e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        input.setAttribute('aria-invalid', 'true');
        say(d.errorEmail || 'Please enter a full email address, like name@example.com.');
        input.focus();
        return;
      }
      if (editor) { showDone(); return; }
      submitBtn.disabled = true;
      submitBtn.classList.add('is-busy');
      say('');
      fetch(d.endpoint, {
        method: 'POST',
        mode: 'cors',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email: email, page: location.pathname, ms: Date.now() - openedAt, website: form.elements.website.value })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (b) { return { status: r.status, body: b }; }); })
        .then(function (res) {
          if (res.body && res.body.ok) return showDone();
          if (res.body && res.body.error === 'email') { input.setAttribute('aria-invalid', 'true'); say('That email address does not look right. Please check it and try again.'); return; }
          if (res.status === 429) { say('Too many tries from this connection. Please wait a few minutes and try again.'); return; }
          say('Something went wrong on our end. Please try again in a minute.');
        })
        .catch(function () { say('We could not reach the server. Please check your connection and try again.'); })
        .then(function () { if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('is-busy'); } });
    }

    function showDone(quiet) {
      if (!editor) write({ done: true, at: Date.now() });
      root.querySelector('[data-v95-ep-step="form"]').hidden = true;
      root.querySelector('[data-v95-ep-step="done"]').hidden = false;
      if (quiet || editor) return;
      root.querySelector('[data-v95-ep-done-title]').focus({ preventScroll: true });
      try { window.dataLayer && window.dataLayer.push({ event: 'v95_email_signup', signup_source: 'popup' }); } catch (e) {}
      try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('v95_email_signup', { source: 'popup' }); } catch (e) {}
    }

    function copy() {
      var b = root.querySelector('[data-v95-ep-copy]');
      var label = b.textContent;
      var code = root.querySelector('[data-v95-ep-code]').textContent.trim();
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () {
        b.textContent = '✓';
        setTimeout(function () { b.textContent = label; }, 2000);
      }, function () {});
    }

    // ---------- triggers ----------
    function onScroll() {
      if (Number(d.scrollPx) > 0 && scrollY >= Number(d.scrollPx)) return open();
      var h = document.documentElement.scrollHeight - innerHeight;
      if (Number(d.scroll) > 0 && h > 0 && (scrollY / h) * 100 >= Number(d.scroll)) open();
    }
    function cleanupTriggers() { clearTimeout(timer); removeEventListener('scroll', onScroll); }

    function destroy() {
      dead = true;
      cleanupTriggers();
      document.removeEventListener('keydown', onKey);
      document.documentElement.classList.remove('v95-ep-lock');
      document.querySelectorAll('body > [data-v95-ep]').forEach(function (n) { n.remove(); });
      root = null;
    }

    if (editor) return api; // editor: opens only while the section is selected
    if (force) { open(); return api; }
    if (Number(d.delay) > 0) timer = setTimeout(open, Number(d.delay));
    if (Number(d.scroll) > 0 || Number(d.scrollPx) > 0) addEventListener('scroll', onScroll, { passive: true });
    return api;
  }

  // theme editor: rebuild after every change to the section
  if (window.Shopify && Shopify.designMode && !window.__v95EpEditor) {
    window.__v95EpEditor = true;
    document.addEventListener('shopify:section:unload', function (e) {
      if (current && e.target.querySelector && e.target.querySelector('[data-v95-ep-config]')) { current.destroy(); current = null; }
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector && e.target.querySelector('[data-v95-ep-config]')) setTimeout(function () { start(); if (current) current.open(); }, 50);
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (current && e.target.querySelector && e.target.querySelector('[data-v95-ep-config]')) current.open();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (current && e.target.querySelector && e.target.querySelector('[data-v95-ep-config]')) current.close();
    });
  }
  if (!window.__v95EpStarted) { window.__v95EpStarted = true; start(); }
})();
